import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

export const RadioButton = ({checked, onClick, userpilot, disabled, cy}) => {
	return (
		<StyledInput
			type="radio"
			checked={checked}
			onClick={onClick}
			data-userpilot={userpilot}
			data-cy={cy}
			disabled={disabled}
		></StyledInput>
	);
};

const StyledInput = Styled.input`
	cursor: pointer;
	display: flex;
	height: 22px;
    width: 22px;
    appearance: none;
    border: solid 2px ${props => (props.theme.colors !== undefined ? props.theme.colors.veryLightGray : '#e6e6e6')};
    border-radius: 11px;
    transition: background-color 0.2s ease;
    background-color: ${props =>
		props.theme.colors ? (props.disabled ? props.theme.colors.mediumGray : props.theme.colors.white) : '#fff'}; 
    &:hover, &:focus, &:checked {
		${props =>
			!props.disabled
				? props.theme.colors
					? 'border: solid 2px ' + props.theme.colors.forecastPurple + ';'
					: 'border: solid 2px #6e0fea;'
				: ''}
	}
    &:checked{
        background-color: ${props =>
			!props.disabled ? (props.theme.colors ? props.theme.colors.forecastPurple : '#6e0fea') : '#D7C1F9'};
    }
    &:after {
        content: '';
		position: relative;
		background: ${props => (props.disabled ? props.theme.colors.mediumGray : 'white')};
        width: 6px;
        height: 6px;
		border-radius: 3px;
		left: 6px;
		top: 6px;
	}
    &:focus{
        outline: none;
    }
`;

RadioButton.propTypes = {
	/**
	 * The element is checked or not.
	 */
	checked: PropTypes.bool,

	/**
	 * Callback of the input.
	 */
	onClick: PropTypes.func,

	userpilot: PropTypes.string,
	cy: PropTypes.string,

	disabled: PropTypes.bool,
};

RadioButton.defaultProps = {
	checked: false,
};
